var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const mimeTypes = ['video/mp4', 'video/webm;codecs=h264', 'video/webm;codecs=vp8'];
/**
 * 获取有效的mimeType
 * - 目前只支持: 'video/mp4', 'video/webm;codecs=h264', 'video/webm;codecs=vp8'
 */
const getValidMimeType = (mimeType) => {
    if (mimeType && MediaRecorder.isTypeSupported(mimeType)) {
        return mimeType;
    }
    for (let i = 0; i < mimeTypes.length; i++) {
        if (MediaRecorder.isTypeSupported(mimeTypes[i])) {
            return mimeTypes[i];
        }
        if (i >= mimeTypes.length - 1) {
            return undefined;
        }
    }
};
export class AVRecorder {
    constructor(stream, options) {
        this.chunks = [];
        options = Object.assign({
            audioBitsPerSecond: stream.getAudioTracks().length !== 0 ? 64000 : undefined,
            videoBitsPerSecond: stream.getVideoTracks().length !== 0 ? 2500000 : undefined,
            onerror: (e) => {
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                console.error(e.error);
            }
        }, options);
        options.mimeType = getValidMimeType(options === null || options === void 0 ? void 0 : options.mimeType);
        if (options.mimeType === undefined) {
            throw new Error('No MimeType is supported');
        }
        this.recorder = new MediaRecorder(stream, {
            audioBitsPerSecond: options.audioBitsPerSecond,
            mimeType: options.mimeType,
            videoBitsPerSecond: options.videoBitsPerSecond
        });
        this.recorder.ondataavailable = (e) => {
            if (e.data) {
                this.chunks.push(e.data);
            }
        };
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        this.recorder.onerror = options.onerror;
    }
    /**
     * 开始录像
     * @param timeslice 时间分片
     */
    start(timeslice = 1000) {
        return __awaiter(this, void 0, void 0, function* () {
            return new Promise(resolve => {
                this.recorder.onstart = () => {
                    resolve();
                };
                this.recorder.start(timeslice);
            });
        });
    }
    /**
     * 停止录像
     */
    stop() {
        return __awaiter(this, void 0, void 0, function* () {
            return new Promise(resolve => {
                this.recorder.onstop = () => {
                    resolve();
                };
                this.recorder.stop();
            });
        });
    }
    /**
     * 关闭AVRecorder，释放资源
     * @param stream
     */
    close(stream) {
        if (this.recorder) {
            if (this.recorder.state === 'recording') {
                this.recorder.stop();
            }
            this.recorder.onstart = null;
            this.recorder.onstop = null;
            this.recorder.ondataavailable = null;
            this.recorder.onerror = null;
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            this.recorder = undefined;
        }
        this.chunks = [];
        stream === null || stream === void 0 ? void 0 : stream.getTracks().forEach(track => track.stop());
    }
    data() {
        return new Blob(this.chunks, { 'type': this.recorder.mimeType });
    }
}
